// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetFiltersWebRequest,
  TGetFiltersWebModel,
  IMappers,
  TGetFiltersWebResponse,
  IGetFiltersWebResponse,
  IGetFiltersWebResponseError,
} from './types';

export const defaultConfig: TGetFiltersWebModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'price-estimator',
  pathApi: '/v3/get-filters-web/',
} as TGetFiltersWebModel;

export function createGetFiltersWebModel(parameters: IGetFiltersWebRequest): TGetFiltersWebModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetFiltersWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetFiltersWebRequest;
}

export async function fetchGetFiltersWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetFiltersWebOptions<TResponse200, TResponse400>): Promise<TGetFiltersWebResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetFiltersWebModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFiltersWebResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetFiltersWebResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetFiltersWebResponse;
}
